import { styled } from "sharedUI/styles";

export const BaseScreenStyle = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 22px 25px;

    background-color: ${p => p.theme.bgColorAlt};

    overflow-y: auto;

    color: ${p => p.theme.fgColorDark};

    /* &.fade-enter {
        opacity: 0;
        z-index: 1;
    }

    &.fade-enter-active {
        opacity: 1;
        z-index: 1;
        transition: opacity 250ms;
    }

    &.fade-enter-done {
        z-index: 1;
    } */
`;
